var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 5.8V14.2M13.0051 5.8V10.2M19.1418 5.8V18.2M3 25H23C24.1046 25 25 24.1046 25 23V3C25 1.89543 24.1046 1 23 1H3C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/ProjectsIcon.5371e0de3d775a5af7a6b39566f32c10.svg";
export { ForwardRef as ReactComponent };